import BaseService from "./baseService";

class AuthService extends BaseService {
  constructor() {
    super("");
  }

  async loginWithGoogle(code: string): Promise<any> {
    return this.post(`/google-auth`, {
      code,
      redirectUri: window.location.origin,
    });
  }

  async logout(): Promise<any> {
    return this.remove(`/logout`);
  }
}

export default new AuthService();
